import script from "./ConfirmDeleteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmDeleteDialog.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmDeleteDialog.vue?vue&type=style&index=0&id=2c5e24ea&scoped=true&lang=css"

import exportComponent from "/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c5e24ea"]])

export default __exports__